import React from 'react';
import PropTypes from 'prop-types';
import {Drawer} from '@learningblocks/protocol-components';
import {NotebookSections} from './NotebookSections';
import {NotebookSectionsHeader} from './NotebookSectionsHeader';
import {NotebookSectionsList} from './NotebookSectionsList';
import {NotebookContent} from '../NotebookContent';
import {ProtocolOptions} from '../ProtocolOptions';
import {NOTEBOOK_SECTIONS} from '@learningblocks/protocol-constants/lib/Utilities';
import './style.scss';

export class Notebook extends React.Component {

  getLevelString = (id) => {

    let dict = {
      1: "one",
      2: "two",
      3: "three"
    }

    return "Level "+dict[id];
  }

  renderProtocolContent = () => {
    return (
      (this.props.notebookSectionListVisible)?(
        <NotebookSections>
          <NotebookSectionsHeader level={
            (this.props.simulationLevels.length > 1)?this.getLevelString(this.props.levelSelected.id):null
          } />
          <ProtocolOptions />
        </NotebookSections>
      ):null
    );
  };
  renderSectionContent = () => {
    return (
      <>
        <NotebookContent />
        {(this.props.notebookSectionListVisible)?(
          <NotebookSections>
            <NotebookSectionsHeader level={
            (this.props.simulationLevels.length > 1)?this.getLevelString(this.props.levelSelected.id):null
          } />
            <NotebookSectionsList />
          </NotebookSections>
        ):null}
      </>
    );
  };
  renderByProps = () => {
    if (this.props.currentSectionType === NOTEBOOK_SECTIONS.PROTOCOL) {
      return this.renderProtocolContent();
    } else {
      return this.renderSectionContent();
    }
  };
  render() {
    return (
      <Drawer expanded={(this.props.currentSectionType !== NOTEBOOK_SECTIONS.PROTOCOL)}>
        <div className='notebook'>{this.renderByProps()}</div>
      </Drawer>
    );
  }
}
Notebook.propTypes = {
  currentSectionType: PropTypes.string,
};
